//全局变量   监听  检测用户已登录
const online = null;
export default {
  online,
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js